<template>
<v-container fluid>
<v-row>
<v-col cols="12">
   <v-card>
     <v-card-title>
       <v-row>
            <v-spacer></v-spacer>
            <v-col cols="12" md="4">
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            </v-col>
        </v-row>
     </v-card-title>
     <v-card-text>
    <v-data-table :headers="headers" :items="pendingRecords"  item-key="id" class="elevation-1" :search="search">
     <template v-slot:[`item.actions`]="{ item }">
      <v-btn @click="showApproveDialog(item)" color="primary"> Approve </v-btn>
    </template>
    </v-data-table>
     </v-card-text>
   </v-card>
</v-col>
</v-row>
<v-dialog v-model="approveDialog" persistent max-width="500">
    <v-card>
      <v-card-title class="headline accent--text">Approve GRN Record</v-card-title>
      <v-card-text>
        <v-row>
            <v-col cols="12" md="6">
                <p> Are you sure you want to approve? </p>
            </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="white" class="accentd--text" style="font-weight: 700;"  @click="approveDialog = false">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="secondary"  @click="triggerApproveRecord">Approve</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-container>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'grnfiledetails',
  data: function () {
    return {
      headers: [
        { text: 'OutTurn', value: 'outTurnNumber' },
        { text: 'Grade', value: 'grade' },
        { text: 'Marks', value: 'marks' },
        { text: 'Bags', value: 'bags' },
        { text: 'Pockets', value: 'pockets' },
        { text: 'Season', value: 'season' },
        { text: 'Sale Number', value: 'saleNumber' },
        { text: 'Miller', value: 'millerCode' },
        { text: 'Gross W', value: 'grossWeight' },
        { text: 'Tare W', value: 'tareWeight' },
        { text: 'Net W', value: 'netWeight' },
        { text: 'Status', value: 'status.statusName' },
        { text: 'Actions', value: 'actions' }
      ],
      search: '',
      grnRecord: {},
      approveDialog: false
    }
  },
  watch: {
  },
  computed: {
    ...mapState({
      records: state => state.grnfile.records,
      pendingRecords: state => state.grnfile.pendingRecords
    })
  },
  methods: {
    ...mapActions({ millerApproveRecord: 'grnfile/millerApproveRecord' }),
    showApproveDialog (item) {
      this.grnRecord = item
      this.approveDialog = true
    },
    triggerApproveRecord () {
      this.millerApproveRecord(this.grnRecord).then(response => {
        if (response.data.error === false) {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'primary', message: response.data.message })
        } else {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: response.data.message })
        }
        this.$store.dispatch('grnfile/getRecordsPendingApproval')
        this.approveDialog = false
      }).catch(error => {
        this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
        this.editDialog = false
      })
    }
  },
  created () {
    this.$store.dispatch('grnfile/getRecordsPendingApproval')
  }
}
</script>
<style>
</style>
